import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { customersApi } from '../api';
import { useFetch } from '../hooks/useFetch';
import toast from 'react-hot-toast';

function CustomerModal({ customer, onClose, onSaved }) {
  const empty = {
    shirt: { length: '', shoulder: '', upper_chest: '', middle_chest: '', lower_chest: '', sleeve_length: '', sleeve_bicep: '', sleeve_kaf: '', collar: '' },
    pant: { length: '', waist: '', thigh: '', bottom: '' },
    pathani: { length: '', shoulder: '', upper_chest: '', middle_chest: '', lower_chest: '', sleeve_length: '', sleeve_bicep: '', sleeve_kaf: '', collar: '' },
    suit: { length: '', shoulder: '', upper_chest: '', middle_chest: '', lower_chest: '', sleeve_length: '', sleeve_bicep: '', sleeve_kaf: '', collar: '' },
    sherwani: { length: '', shoulder: '', upper_chest: '', middle_chest: '', lower_chest: '', sleeve_length: '', sleeve_bicep: '', sleeve_kaf: '', collar: '' },
    jacket: { length: '', shoulder: '', upper_chest: '', middle_chest: '', lower_chest: '', sleeve_length: '', sleeve_bicep: '', sleeve_kaf: '', collar: '' },
  };

  const [form, setForm] = useState(customer ? {
    name: customer.name, phone: customer.phone, email: customer.email || '',
    address: customer.address || '', measurements: customer.measurements || empty,
  } : { name: '', phone: '', email: '', address: '', measurements: empty });
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState("shirt");

  const handleSubmit = async (e) => {
    e.preventDefault();
    //  Validation
    if (!form.name) {
      return toast.error("Full Name is required");
    }

    if (!form.phone) {
      return toast.error("Phone number is required");
    }

    //  Phone validation 
    if (!/^[6-9]\d{9}$/.test(form.phone)) {
      return toast.error("Enter valid 10-digit phone number");
    }

    //  Email validation 
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
      return toast.error("Enter valid email address");
    }
    setLoading(true);
    try {
      if (customer) await customersApi.update(customer.id, form);
      else await customersApi.create(form);
      toast.success(customer ? 'Customer updated' : 'Customer created');
      onSaved(); onClose();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 600 }}>
        <div className="modal-header">
          <h3>{customer ? 'Edit Customer' : 'New Customer'}</h3>
          <button className="btn btn-secondary btn-sm btn-icon" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-row form-row-2">
              <div className="form-group"><label className="form-label">Full Name *</label><input className="form-control" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Phone *</label><input className="form-control" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            </div>
            <div className="form-row form-row-2">
              <div className="form-group"><label className="form-label">Email</label><input type="email" className="form-control" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Address</label><input className="form-control" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
            </div>
            <hr className="divider" />
            <p className="text-xs text-muted font-semibold mb-4" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>Body Measurements (inches)</p>
            {/* <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
              <button type="button" onClick={() => setTab("shirt")} className={tab === "shirt" ? "btn btn-primary" : "btn btn-secondary"}>Shirt</button>
              <button type="button" onClick={() => setTab("pant")} className={tab === "pant" ? "btn btn-primary" : "btn btn-secondary"}>Pant</button>
            
            </div> */}
            <div className="form-group" style={{ marginBottom: 20 }}>
              <label className="form-label">Select Measurement Type</label>

              <select
                className="form-control"
                value={tab}
                onChange={(e) => setTab(e.target.value)}
              >
                {Object.keys(form.measurements).map((type) => (
                  <option key={type} value={type}>
                    {type.charAt(0).toUpperCase() + type.slice(1)}
                  </option>
                ))}
              </select>
            </div>
            {/* Shirt Measurements - Organized Sections */}
            {tab === 'shirt' && (
              <div className="measurements-section shirt-measurements">
                <div className="measurement-row">
                  <label htmlFor="">Length:</label>
                  <input
                    type="text"
                    placeholder='Length'
                    className="measurement-input"
                    value={form.measurements.shirt.length || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          shirt: { ...f.measurements.shirt, length: e.target.value }
                        }
                      }))
                    }
                  />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Shoulder:</label>
                  <input
                    type="text"
                    placeholder='Shoulder'
                    className="measurement-input"
                    value={form.measurements.shirt.shoulder || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          shirt: { ...f.measurements.shirt, shoulder: e.target.value }
                        }
                      }))
                    }
                  />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Chest:</label>
                  <div className="measurement-inputs-group">
                    <input
                      type="text"
                      className="measurement-input"
                      placeholder='upper chest'
                      value={form.measurements.shirt.upper_chest || ""}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          measurements: {
                            ...f.measurements,
                            shirt: { ...f.measurements.shirt, upper_chest: e.target.value }
                          }
                        }))
                      }
                    />
                    <input
                      type="text"
                      className="measurement-input"
                      placeholder='middle chest'
                      value={form.measurements.shirt.middle_chest || ""}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          measurements: {
                            ...f.measurements,
                            shirt: { ...f.measurements.shirt, middle_chest: e.target.value }
                          }
                        }))
                      }
                    />
                    <input
                      type="text"
                      className="measurement-input"
                      placeholder='lower chest'
                      value={form.measurements.shirt.lower_chest || ""}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          measurements: {
                            ...f.measurements,
                            shirt: { ...f.measurements.shirt, lower_chest: e.target.value }
                          }
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Sleeve:</label>
                  <div className="measurement-inputs-group">
                    <input
                      type="text"
                      className="measurement-input"
                      placeholder='sleeve length'
                      value={form.measurements.shirt.sleeve_length || ""}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          measurements: {
                            ...f.measurements,
                            shirt: { ...f.measurements.shirt, sleeve_length: e.target.value }
                          }
                        }))
                      }
                    />
                    <input
                      type="text"
                      className="measurement-input"
                      placeholder='sleeve bicep'
                      value={form.measurements.shirt.sleeve_bicep || ""}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          measurements: {
                            ...f.measurements,
                            shirt: { ...f.measurements.shirt, sleeve_bicep: e.target.value }
                          }
                        }))
                      }
                    />
                    <input
                      type="text"
                      className="measurement-input"
                      placeholder='sleeve Kaf'
                      value={form.measurements.shirt.sleeve_kaf || ""}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          measurements: {
                            ...f.measurements,
                            shirt: { ...f.measurements.shirt, sleeve_kaf: e.target.value }
                          }
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">collar:</label>
                  <input
                    type="text"
                    className="measurement-input"
                    placeholder='Collar'
                    value={form.measurements.shirt.collar || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          shirt: { ...f.measurements.shirt, collar: e.target.value }
                        }
                      }))
                    }
                  />
                </div>
              </div>
            )}

            {/* Pant Measurements - Organized Sections */}
            {tab === 'pant' && (
              <div className="measurements-section shirt-measurements">
                <div className="measurement-row">
                  <label htmlFor="">Length:</label>
                  <input
                    type="text"
                    placeholder='Length'
                    className="measurement-input"
                    value={form.measurements.pant.length || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          pant: { ...f.measurements.pant, length: e.target.value }
                        }
                      }))
                    }
                  />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">waist:</label>
                  <input
                    type="text"
                    placeholder='waist'
                    className="measurement-input"
                    value={form.measurements.pant.waist || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          pant: { ...f.measurements.pant, waist: e.target.value }
                        }
                      })) 
                    }
                  />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Thigh:</label>
                  <input
                    type="text"
                    className="measurement-input"
                    placeholder='thigh'
                    value={form.measurements.pant.thigh || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          pant: { ...f.measurements.pant, thigh: e.target.value }
                        }
                      }))
                    }
                  />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">bottom:</label>
                  <input
                    type="text"
                    className="measurement-input"
                    placeholder='bottom'
                    value={form.measurements.pant.bottom || ""}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        measurements: {
                          ...f.measurements,
                          pant: { ...f.measurements.pant, bottom: e.target.value }
                        }
                      }))
                    }
                  />
                </div>
              </div>
            )}

            {/* Pathani */}
            {tab === 'pathani' && (
              <div className="measurements-section shirt-measurements">
                <div className="measurement-row">
                  <label htmlFor="">Length:</label>
                  <input type="text" placeholder='Length' className="measurement-input" value={form.measurements.pathani.length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, length: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Shoulder:</label>
                  <input type="text" placeholder='Shoulder' className="measurement-input" value={form.measurements.pathani.shoulder || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, shoulder: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Chest:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='upper chest' value={form.measurements.pathani.upper_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, upper_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='middle chest' value={form.measurements.pathani.middle_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, middle_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='lower chest' value={form.measurements.pathani.lower_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, lower_chest: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Sleeve:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='sleeve length' value={form.measurements.pathani.sleeve_length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, sleeve_length: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve bicep' value={form.measurements.pathani.sleeve_bicep || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, sleeve_bicep: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve Kaf' value={form.measurements.pathani.sleeve_kaf || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, sleeve_kaf: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">collar:</label>
                  <input type="text" className="measurement-input" placeholder='Collar' value={form.measurements.pathani.collar || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, pathani: { ...f.measurements.pathani, collar: e.target.value } } }))} />
                </div>
              </div>
            )}

            {/* Suit */}
            {tab === 'suit' && (
              <div className="measurements-section shirt-measurements">
                <div className="measurement-row">
                  <label htmlFor="">Length:</label>
                  <input type="text" placeholder='Length' className="measurement-input" value={form.measurements.suit.length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, length: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Shoulder:</label>
                  <input type="text" placeholder='Shoulder' className="measurement-input" value={form.measurements.suit.shoulder || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, shoulder: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Chest:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='upper chest' value={form.measurements.suit.upper_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, upper_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='middle chest' value={form.measurements.suit.middle_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, middle_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='lower chest' value={form.measurements.suit.lower_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, lower_chest: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Sleeve:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='sleeve length' value={form.measurements.suit.sleeve_length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, sleeve_length: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve bicep' value={form.measurements.suit.sleeve_bicep || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, sleeve_bicep: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve Kaf' value={form.measurements.suit.sleeve_kaf || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, sleeve_kaf: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">collar:</label>
                  <input type="text" className="measurement-input" placeholder='Collar' value={form.measurements.suit.collar || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, suit: { ...f.measurements.suit, collar: e.target.value } } }))} />
                </div>
              </div>
            )}

            {/* Sherwani */}
            {tab === 'sherwani' && (
              <div className="measurements-section shirt-measurements">
                <div className="measurement-row">
                  <label htmlFor="">Length:</label>
                  <input type="text" placeholder='Length' className="measurement-input" value={form.measurements.sherwani.length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, length: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Shoulder:</label>
                  <input type="text" placeholder='Shoulder' className="measurement-input" value={form.measurements.sherwani.shoulder || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, shoulder: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Chest:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='upper chest' value={form.measurements.sherwani.upper_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, upper_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='middle chest' value={form.measurements.sherwani.middle_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, middle_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='lower chest' value={form.measurements.sherwani.lower_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, lower_chest: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Sleeve:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='sleeve length' value={form.measurements.sherwani.sleeve_length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, sleeve_length: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve bicep' value={form.measurements.sherwani.sleeve_bicep || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, sleeve_bicep: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve Kaf' value={form.measurements.sherwani.sleeve_kaf || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, sleeve_kaf: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">collar:</label>
                  <input type="text" className="measurement-input" placeholder='Collar' value={form.measurements.sherwani.collar || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, sherwani: { ...f.measurements.sherwani, collar: e.target.value } } }))} />
                </div>
              </div>
            )}

            {/* Jacket */}
            {tab === 'jacket' && (
              <div className="measurements-section shirt-measurements">
                <div className="measurement-row">
                  <label htmlFor="">Length:</label>
                  <input type="text" placeholder='Length' className="measurement-input" value={form.measurements.jacket.length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, length: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Shoulder:</label>
                  <input type="text" placeholder='Shoulder' className="measurement-input" value={form.measurements.jacket.shoulder || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, shoulder: e.target.value } } }))} />
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Chest:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='upper chest' value={form.measurements.jacket.upper_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, upper_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='middle chest' value={form.measurements.jacket.middle_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, middle_chest: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='lower chest' value={form.measurements.jacket.lower_chest || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, lower_chest: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">Sleeve:</label>
                  <div className="measurement-inputs-group">
                    <input type="text" className="measurement-input" placeholder='sleeve length' value={form.measurements.jacket.sleeve_length || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, sleeve_length: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve bicep' value={form.measurements.jacket.sleeve_bicep || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, sleeve_bicep: e.target.value } } }))} />
                    <input type="text" className="measurement-input" placeholder='sleeve Kaf' value={form.measurements.jacket.sleeve_kaf || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, sleeve_kaf: e.target.value } } }))} />
                  </div>
                </div>
                <div className="measurement-row">
                  <label htmlFor="">collar:</label>
                  <input type="text" className="measurement-input" placeholder='Collar' value={form.measurements.jacket.collar || ""} onChange={(e) => setForm((f) => ({ ...f, measurements: { ...f.measurements, jacket: { ...f.measurements.jacket, collar: e.target.value } } }))} />
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : (customer ? 'Update' : 'Create')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function Customers() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const fetchCustomers = useCallback(() => customersApi.getAll({ search, page, limit: 20 }), [search, page]);
  const { data, loading, refetch } = useFetch(fetchCustomers, [search, page]);
  const customers = data?.customers || data || [];
  const pagination = data?.pagination;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Customers</h1>
        <button className="btn btn-primary" onClick={() => { setSelected(null); setModal(true); }}>+ New Customer</button>
      </div>

      <div className="filters-bar">
        <div className="search-input" style={{ flex: 1 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>
          <input className="form-control" placeholder="Search by name or phone..." value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
        </div>
      </div>

      <div className="card">
        {loading ? <div className="empty-state"><div className="spinner" /></div> : (
          <div className="table-wrapper" style={{ border: 'none', borderRadius: 0 }}>
            <table>
              <thead><tr><th>Name</th><th>Phone</th><th>Email</th><th>Address</th><th>Measurements</th><th>Actions</th></tr></thead>
              <tbody>
                {customers.length === 0 ? (
                  <tr><td colSpan={6}><div className="empty-state"><div className="empty-icon">👥</div><p>No customers found</p></div></td></tr>
                ) : customers.map((c) => (
                  <tr key={c.id}>
                    <td className="font-semibold" style={{ color: 'var(--text-primary)' }}>{c.name}</td>
                    <td className="mono text-sm">{c.phone}</td>
                    <td className="text-sm text-muted">{c.email || '—'}</td>
                    <td className="text-sm text-muted truncate" style={{ maxWidth: 180 }}>{c.address || '—'}</td>
                    <td>
                      {c.measurements ? (
                        <span className="badge badge-ready">Recorded</span>
                      ) : <span className="badge badge-pending">Missing</span>}
                    </td>
                    <td>
                      <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/customers/${c.id}`)}>View</button>{' '}
                      <button className="btn btn-secondary btn-sm" onClick={() => { setSelected(c); setModal(true); }}>Edit</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {pagination && (
          <div className="pagination">
            <span>Page {pagination.page} of {pagination.totalPages} ({pagination.total} customers)</span>
            <div className="pagination-btns">
              <button className="btn btn-secondary btn-sm" disabled={!pagination.hasPrev} onClick={() => setPage(p => p - 1)}>← Prev</button>
              <button className="btn btn-secondary btn-sm" disabled={!pagination.hasNext} onClick={() => setPage(p => p + 1)}>Next →</button>
            </div>
          </div>
        )}
      </div>

      {modal && <CustomerModal customer={selected} onClose={() => setModal(false)} onSaved={refetch} />}
    </div>
  );
}
